import { useSearchParams } from 'react-router';

import type {
  DialogAdditionalParamKey,
  DialogKey,
} from '#src/components/navigation/WithDialogs/index.tsx';

export const useDialogParam = (
  dialogKey: DialogKey | DialogAdditionalParamKey
) => {
  const [searchParams] = useSearchParams();
  return searchParams.get(dialogKey);
};
